export default __webpack_public_path__ + "static/media/03.1be9c571.png";